import type { IconSize } from '@components/v2/types';
import { useShallow } from 'zustand/react/shallow';
import { MediaFormatEnum } from '../../../modules/general-settings/enums/mediaFormat.enum';
import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';

interface ProductMediaThumbnail {
  aspectRatio: string;
  fallbackIconSize: IconSize;
}

const THUMBNAIL_BY_MEDIA_FORMAT: Record<MediaFormatEnum, ProductMediaThumbnail> = {
  [MediaFormatEnum.SQUARE]: { aspectRatio: '1 / 1', fallbackIconSize: 'md' },
  [MediaFormatEnum.RECTANGULAR]: { aspectRatio: '10 / 16', fallbackIconSize: 'sm' },
};

const useProductMediaThumbnail = (): ProductMediaThumbnail => {
  const { mediaFormat } = useGeneralSettingsStore(
    useShallow((state) => ({ mediaFormat: state.generalSettings.mediaFormat })),
  );

  return THUMBNAIL_BY_MEDIA_FORMAT[mediaFormat] ?? THUMBNAIL_BY_MEDIA_FORMAT.RECTANGULAR;
};

export default useProductMediaThumbnail;
